import type { Domain } from '@/system-logs/entities/domain';
import type { SystemLogLevel } from '@/system-logs/entities/levels';

export type CoreFilters = {
  dateRange: { from?: Date; to?: Date };
  domain: Domain | undefined;
  siteId?: string;
};

export type BatteryLevelIdKey = `${SystemLogLevel}Id`;

export type BatteryIdFilters = Partial<
  Record<BatteryLevelIdKey, string | string[]>
> & { deviceId?: string };

export type PcsFilters = {
  pcsId?: string | string[];
  deviceId?: string;
};

export type AllIdFilters = BatteryIdFilters & PcsFilters;

export type Filters = {
  coreFilters: CoreFilters;
  batteryFilters: BatteryIdFilters;
  pcsFilters: PcsFilters;
};

export const initialFilters: Filters = {
  coreFilters: {
    dateRange: {},
    domain: undefined,
  },
  batteryFilters: {},
  pcsFilters: {},
};
